export default function Temperature() {
    return <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M16 6C17.66 6 19 7.34 19 9V17C20.21 17.91 21 19.37 21 21C21 23.76 18.76 26 16 26C13.24 26 11 23.76 11 21C11 19.37 11.79 17.91 13 17V9C13 7.34 14.34 6 16 6ZM16 8C15.45 8 15 8.45 15 9V15H17V13H16V12H17V10H16V9H17C17 8.45 16.55 8 16 8Z" fill="white" />
    </svg>

}